import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Asset } from "@carnegie-learning/cure-types";

@Component({
    selector: "delete-asset-dialog",
    templateUrl: "./delete-asset-dialog.component.html",
    styleUrls: ["./delete-asset-dialog.component.scss"],
    standalone: false
})
export class DeleteAssetDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DeleteAssetDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { asset: Asset }
    ) {}

    close(bool: boolean): void {
        this.dialogRef.close(bool);
    }
}
